<template>
    <div>
        <div v-if="!loading" class="p-4">
            <b-row>
                <b-col class="text-right">
                    <img src="@/assets/logo-dark.png" class="logo"/>
                </b-col>
            </b-row>

            <h2 class="text-success">{{conference.title}}</h2>

            <div class="mb-3">
                <h4 class="text-success">{{session.title}}</h4>
                <div class="meta">Presented by <strong>{{session.presenter}}</strong></div>
                <date-range :start="session.start_at" :end="session.end_at" class="meta"></date-range>
            </div>
            <h5 class="mb-4">Survey Responses as of {{date}}</h5>

            <hr/>

            <div class="mb-5" v-for="sess in session.survey">
                <h5>{{sess.title}}</h5>

                <div v-if="sess.options">
                    <div class="mb-3">{{optionSummary(sess).total}} <strong>Responses</strong> from {{optionSummary(sess).total+optionSummary(sess).na}} <strong>Surveys</strong></div>
                    <b-table-simple>
                        <b-thead head-variant="light">
                            <b-tr>
                                <b-th>Option</b-th>
                                <b-th>Responses</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(r, t) in optionSummary(sess).options">
                                <b-td>{{t}}</b-td>
                                <b-td>{{r}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
                <div v-if="!sess.options">
                    <div class="mb-3">{{questionResponses(sess).total}} <strong>Responses</strong> from {{questionResponses(sess).total+questionResponses(session).na}} <strong>Surveys</strong></div>

                    <div v-for="(r, index) in questionResponses(sess).responses" class="mt-2 pt-2" style="border-top: 1px solid #ddd;">
                        <strong>{{index+1}}</strong> {{r}}
                    </div>
                </div>
                <hr/>
            </div>


        </div>
        <div v-else class="m-5">
            <h5 class="text-muted"><i class="fas fa-spinner fa-pulse mr-3"></i>Loading details, please wait...</h5>
        </div>
    </div>


</template>

<script>
    import {mapActions} from "vuex";
    import DateRange from "../../../../components/DateRange";
    import moment from 'moment';

    export default {
        name: "sess-surveys",
        components: {DateRange},
        props: ['sessId', 'id'],
        data: function () {
            return {
                loading: true,
                conference: {},
                session: {},
                selectedQuestion: null,
                date: moment().format('MMMM Do YYYY, hh:mm a')
            }
        },
        methods: {
            ...mapActions(['getSessionDetailsById', 'getConferenceById']),


            optionSummary: function (sess) {
                if (this.session && this.session.enrollments) {
                    let results = {
                        total: 0,
                        na: 0,
                        options: {}
                    };

                    for (let i = 0; i < sess.options.length; i++) {
                        const opt = sess.options[i];
                        results.options[opt] = 0;
                    }
                    results.options['No Response'] = 0;

                    for (let i = 0; i < this.session.enrollments.length; i++) {
                        const s = this.session.enrollments[i].survey;

                        for (let j = 0; j < s.length; j++) {
                            if (s[j].field_id === sess.id) {
                                if (s[j].value) {
                                    results.total++;
                                    results.options[s[j].value]++;
                                } else {
                                    results.na++
                                    results.options['No Response']++;
                                }
                                break;
                            }
                        }
                    }
                    return results;
                } else {
                    return {}
                }
            },
            questionResponses: function (sess) {
                if (this.session && this.session.enrollments) {
                    let results = {
                        total: 0,
                        na: 0,
                        responses: []
                    };
                    for (let i = 0; i < this.session.enrollments.length; i++) {
                        const s = this.session.enrollments[i].survey;

                        for (let j = 0; j < s.length; j++) {
                            if (s[j].field_id === sess.id) {
                                if (s[j].value) {
                                    results.total++;
                                    results.responses.push(s[j].value);
                                } else {
                                    results.na++;
                                }
                                break;
                            }
                        }

                    }
                    return results;
                } else {
                    return {}
                }
            }
        },
        mounted: function () {
            this.getSessionDetailsById(this.sessId).then(response => {
                this.session = response;
            });

            this.getConferenceById(this.id).then(conf => {
                this.conference = conf;
                this.loading = false;
            }, err => {
                this.conference = {};
                console.error(err);
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .logo {
        width: 25%;
    }

</style>
